import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'user/EmptyRoles', method: 'GET', body: null, token: token })
}
